import {createApp} from 'vue';
import {createI18n} from 'vue-i18n';
import * as Sentry from "@sentry/vue";

import Order from '@/App.vue';
import router from '@/router/router';
import {handleError} from "./utils/errorHandler";

const sessionLang = document.getElementById('order_spa').dataset.sessionLang;
let allowedLangs = ['en', 'nl'];
if (!allowedLangs.includes(sessionLang)) allowedLangs.push(sessionLang);
const messages = {};

const loadTranslations = async () => {
  for (const lang of allowedLangs) {
    try {
      const response = await fetch(`/${sessionLang}/api/getlanguagefile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({lang: lang, transBaseKey: 'VUE_ORDER'}),
      });

      let json = await response.json();
      messages[lang] = json.data;

    } catch (e) { // even loggen
      await fetch(`/${sessionLang}/api/loglanguageerror`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({msg: `Language file for '${lang}' not found. Loading default.`, error: e})
      });
    }
  }

  const i18n = createI18n({
    locale: sessionLang,
    fallbackLocale: ['en', 'nl'],
    silentTranslationWarn: true,
    silentFallbackWarn: true,
    messages,
  });

  const app = createApp(Order);
  app.config.globalProperties.$sessionLang = sessionLang;
  app.config.globalProperties.$handleError = handleError;

  Sentry.init({
    app,
    dsn: "https://5d3716ca9acfebf619f05f6a0ebb3605@o4508438537175040.ingest.de.sentry.io/4508653053673552",
    integrations: [
      Sentry.browserTracingIntegration({router}),
      Sentry.replayIntegration(),
    ],
    enabled: process.env.NODE_ENV === "production",

    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/www\.heblad\.nl\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });

  app.use(i18n);
  app.use(router);
  app.mount('#order_spa');
};

// Call the function to load translations
loadTranslations()
